<template>
  <div>
      <div class="card">
        <header class="bandeau-modal card-header">
        </header>
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h1 class="title is-size-3">{{ $t('remiseBancaire.ajoutRemise.titre')}}</h1>
            </div>
          </div>
        </div>
        <br>
        <div class="card-content">
        <error-msg-component :messages="messages"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
          <b-field :label="$t('remiseBancaire.ajoutRemise.nomRemise')" type="typeNom">
            <b-input v-model="name"></b-input>
          </b-field>
          <br>
          <b-field>
              <b-field :label="$t('remiseBancaire.ajoutRemise.dateRemise')" class="obligatoire">
                <b-datepicker show-week-number
                  icon="calendar-today"
                  v-model="date"
                  :editable="true"
                  nearby-selectable-month-days
                  >
                </b-datepicker>
              </b-field>
            <b-field :label="$t('remiseBancaire.ajoutRemise.banque')"
                     class="obligatoire mgl-30px">
              <b-select v-model="domiciliationBancaire.selected" expanded>
                <option v-for="domiciliation in loadDomiciliationBancaire"
                        :value="domiciliation.id" :key="domiciliation.id">
                  {{ `${domiciliation.libelle} - ${domiciliation.libelleBanque}` }}
                </option>
              </b-select>
            </b-field>
            <b-field :label="$t('remiseBancaire.ajoutRemise.modeReglement')"
                     class="obligatoire mgl-30px">
              <b-select v-model="modeReglement.selected" expanded>
                <option v-for="reglement in loadModeReglement"
                        :value="reglement.id" :key="reglement.id">
                  {{ reglement.libelle }}
                </option>
              </b-select>
            </b-field>
          </b-field>
          <br>
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="sendEvent">
                {{ $t('remiseBancaire.ajoutRemise.annuler') }}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="createRemiseBancaire">
                {{ $t('general.button.sauvegarder') }}
              </a>
            </div>
          </b-field>
        </div>
      </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatIsoDate';
import translate from '@/services/remiseBancaire/validation/champsRemiseBancaireTranslator';
import validation from '@/services/remiseBancaire/validation/validationRemiseBancaire';
import validationGeneral from '@/services/validation/validation';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import { create } from '@/api/remiseBancaire/index';
import genererRemiseBancaire from '@/services/remiseBancaire/genererRemiseBancaire';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { SENS_VENTE } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'addRemiseBancaire',
  data() {
    return {
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      domiciliationBancaire: {
        liste: [],
        selected: '',
      },
      modeReglement: {
        liste: [],
        selected: '',
      },
      date: new Date(),
      name: '',
      constantes: {
        SENS_VENTE,
      },
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    async createRemiseBancaire() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const remiseBancaire = genererRemiseBancaire();
        remiseBancaire.nom = this.name;
        remiseBancaire.dateRemise = formatDate(this.date);
        remiseBancaire.domiciliationBancaireId = this.domiciliationBancaire.selected;
        remiseBancaire.modeReglementId = this.modeReglement.selected;
        remiseBancaire.societeId = this.societeActiveId;

        const response = await create(remiseBancaire);
        messageSucces(this.$t('remiseBancaire.remiseBancaireAdd'));
        loadingComponent.close();
        await this.$router.push({ name: 'm.bodac.remises_bancaires-editionRemise', params: { id: response.data.result.id } });
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = validation(e.response, this.constantes.SENS_VENTE);
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    sendEvent() {
      this.$emit('close', true);
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    loadDomiciliationBancaire() {
      return this.parametre(
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
      ).filter((domicialisation) => {
        return domicialisation.actif;
      });
    },
    loadModeReglement() {
      return this.parametre(
        typesParametres.PARAMETRES_KEYS.modeReglement,
      );
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.loadParametres([
      typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
      typesParametres.PARAMETRES_KEYS.modeReglement,
    ]);
    loadingComponent.close();
  },
};
</script>

<style scoped>
</style>
